<template>
    <div
        ref="homeBanner"
        class="col-12 w-100 px-0 mx-0 d-flex main-image-wrapper home-banner"
    >
        <div
            v-if="isLoading"
            class="home-banner__loading"
        >
            <van-loading
                type="spinner"
                color="#0D3B1A"
                class="mx-auto"
            />
        </div>
        <b-carousel
            v-else
            id="carousel-1"
            :interval="3000"
            controls
            fade
            class="home-banner__carousel w-100"
        >
            <b-carousel-slide
                v-for="banner in banners"
                :key="banner.id"
                :img-src="banner.image"
            />
        </b-carousel>
    </div>
</template>

<script>
import { Loading } from 'vant';

const LOCAL_BANNERS = [
    { id: 'banner-1', image: '/assets/Banner1.webp' },
    { id: 'banner-2', image: '/assets/Banner2.webp' },
    { id: 'banner-3', image: '/assets/Banner3.webp' },
];

const FALLBACK_BANNER = { id: 'logo', image: '/assets/12k-new.avif' };

function imageExists(src) {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = src;
    });
}

export default {
    name: 'HomeBanner',
    components: { [Loading.name]: Loading },
    data() {
        return {
            isLoading: true,
            banners: LOCAL_BANNERS,
        };
    },
    async mounted() {
        await this.fetchBanners();

        const isDesktopFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        if (isDesktopFinePointer) {
            this.$nextTick(() => {
                this.setupDesktopBannerWheel();
            });
        }
    },
    beforeDestroy() {
        this.teardownDesktopBannerWheel();
    },
    methods: {
        async fetchBanners() {
            this.isLoading = true;
            const checks = await Promise.all(
                LOCAL_BANNERS.map(async (banner) => ((await imageExists(banner.image)) ? banner : null))
            );
            const available = checks.filter(Boolean);
            this.banners = available.length ? available : [FALLBACK_BANNER];
            this.isLoading = false;
        },
        setupDesktopBannerWheel() {
            const banner = this.$refs.homeBanner;
            if (!banner) return;

            this._onHomeBannerWheel = (event) => {
                const scrollContainer = banner.closest('.home-lobby')?.querySelector('.index_rightbar')
                    || banner.closest('.index-scroll-main');
                if (!scrollContainer) return;

                scrollContainer.scrollTop += event.deltaY;
                event.preventDefault();
            };

            banner.addEventListener('wheel', this._onHomeBannerWheel, { passive: false });
            this._homeBannerWheelEl = banner;
        },
        teardownDesktopBannerWheel() {
            if (this._homeBannerWheelEl && this._onHomeBannerWheel) {
                this._homeBannerWheelEl.removeEventListener('wheel', this._onHomeBannerWheel);
                this._homeBannerWheelEl = null;
                this._onHomeBannerWheel = null;
            }
        },
    },
};
</script>

<style scoped>
.home-banner {
    max-width: 100%;
    overflow: hidden;
    background: #FFFFFF;
}

.home-banner__carousel {
    width: 100%;
    height: auto;
}

.home-banner__loading {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 180px;
    background: #FFFFFF;
}

.home-banner ::v-deep .carousel,
.home-banner ::v-deep .carousel-inner,
.home-banner ::v-deep .carousel-item {
    background: #FFFFFF !important;
    border-radius: 0 !important;
    height: auto !important;
}

.home-banner ::v-deep .carousel-item img,
.home-banner ::v-deep img {
    width: 100%;
    height: auto !important;
    display: block;
    border-radius: 0 !important;
}

@media (hover: hover) and (pointer: fine) {
    .home-banner {
        touch-action: pan-y;
    }
}
</style>
